import React from 'react';
import { SortingColumnsContext } from '@vizsla/providers';
export const useSortingColumns = () => {
    return React.useContext(SortingColumnsContext);
};
